/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Branding_Avatar_CtaInputs */

const cs_templates_branding_avatar_cta = /** @type {(inputs: Templates_Branding_Avatar_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doplnit avatar v profilu`)
};

const en_templates_branding_avatar_cta = /** @type {(inputs: Templates_Branding_Avatar_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add avatar in profile`)
};

/**
* | output |
* | --- |
* | "Add avatar in profile" |
*
* @param {Templates_Branding_Avatar_CtaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_branding_avatar_cta = /** @type {((inputs?: Templates_Branding_Avatar_CtaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Branding_Avatar_CtaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_branding_avatar_cta(inputs)
	return cs_templates_branding_avatar_cta(inputs)
});